module.exports = __webpack_public_path__ + "img/concrete-hole-decal-08.58f54467.png";